/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React, { useMemo, useLayoutEffect, useEffect } from "react";
import { useLocation } from "react-router-dom";

import objectPath from "object-path";

import { useHtmlClassService } from "../../_core/MetronicLayout";
import {
  getBreadcrumbsAndTitle,
  useSubheader
} from "../../_core/MetronicSubheader";

import { BreadCrumbs } from "./components/BreadCrumbs";

export function SubHeader() {
  const uiService = useHtmlClassService();

  const location = useLocation();

  const subheader = useSubheader();

  const layoutProps = useMemo(() => {
    return {
      config: uiService.config,
      subheaderMobileToggle: objectPath.get(
        uiService.config,
        "subheader.mobile-toggle"
      ),
      subheaderCssClasses: uiService.getClasses("subheader", true),
      subheaderContainerCssClasses: uiService.getClasses(
        "subheader_container",
        true
      )
    };
  }, [uiService]);

  useLayoutEffect(() => {
    const aside = getBreadcrumbsAndTitle("kt_aside_menu", location.pathname);

    const header = getBreadcrumbsAndTitle("kt_header_menu", location.pathname);

    let breadcrumbs =
      aside && aside.breadcrumbs.length > 0
        ? aside.breadcrumbs
        : header.breadcrumbs;
    subheader.setTitle(
      aside && aside.title && aside.title.length > 0
        ? aside.title
        : header.title
    );
    breadcrumbs = breadcrumbs.filter(bc => {
      return bc.title !== subheader.title;
    });
    subheader.setBreadcrumbs(breadcrumbs);
    // eslint-disable-next-line
  }, [location.pathname]);

  // Do not remove this useEffect, need from update title/breadcrumbs outside (from the page)
  useEffect(() => {}, [subheader]);

  return (
    <div
      className={`${layoutProps.subheaderContainerCssClasses} d-flex align-items-center justify-content-between flex-wrap flex-sm-nowrap`}
    >
      {/* Info */}
      <div className="d-flex align-items-center flex-wrap mr-1">
        {layoutProps.subheaderMobileToggle && (
          <button
            className="burger-icon burger-icon-left mr-4 d-inline-block d-lg-none"
            id="kt_subheader_mobile_toggle"
          >
            <span />
          </button>
        )}
        <div className="d-flex align-items-baseline mr-5">
          <h5 className="text-dark font-weight-bold my-2 mr-5">
            <>{subheader.title}</>
            {/*<small></small>*/}
          </h5>
        </div>
        {subheader.breadcrumbs.filter(bc => bc.title === subheader.title)
          .length === 0 && <BreadCrumbs items={subheader.breadcrumbs} />}
      </div>
    </div>
  );
}
